"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getQuickFactAPY", {
  enumerable: true,
  get: function get() {
    return _banking.getDriverApy;
  }
});
Object.defineProperty(exports, "getQuickFactBonus", {
  enumerable: true,
  get: function get() {
    return _banking.getDriverBonus;
  }
});
Object.defineProperty(exports, "getQuickFactMinimumBalance", {
  enumerable: true,
  get: function get() {
    return _banking.getDriverMinimumBalance;
  }
});
Object.defineProperty(exports, "getQuickFactMonthlyFee", {
  enumerable: true,
  get: function get() {
    return _banking.getDriverMonthlyFee;
  }
});
Object.defineProperty(exports, "getQuickFactOutOfNetworkATMFee", {
  enumerable: true,
  get: function get() {
    return _banking.getDriverOutOfNetworkAtmFee;
  }
});
var _banking = require("@nerdwallet/marketplace/drivers/banking");